import React from 'react';

import colors from 'utils/colors';

type Props = {
  /**
   * When selected - highlights the thumb with the Service Vic orange color
   */
  selected?: boolean;
  /**
   * When disabled & not selected - highlights the thumb with a grey color, indicating unable to interact
   */
  disabled?: boolean;
} & React.SVGProps<SVGSVGElement>;

export const ThumbDownIcon: React.FC<Props> = ({
  selected = false,
  disabled = false,
  ...props
}) => {
  return (
    <svg
      viewBox='0 0 24 24'
      fill={selected ? colors.orange : disabled ? '#707070' : colors.blueGrey}
      height='24'
      width='24'
      {...props}>
      <path d='M0 0h24v24H0z' fill='none' />
      <path d='M15 3H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v2c0 1.1.9 2 2 2h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 23l6.59-6.59c.36-.36.58-.86.58-1.41V5c0-1.1-.9-2-2-2zm4 0v12h4V3h-4z' />
    </svg>
  );
};

export default ThumbDownIcon;
